module.exports = __webpack_public_path__ + "static/ArboriaBook-05569a71767cda040b5b9b1c5c1d2207.ttf";